import React, { useEffect, useState } from "react";
import { getQuotationsApi } from "../api/quotationApi";
import { deleteQuotationApi } from "../api/quotationApi";

const QuotationList = () => {
  const [quotations, setQuotations] = useState([]);

  const fetchQuotations = async () => {
    try {
      const res = await getQuotationsApi();

      const data =
        res.data.data ||
        res.data.quotations ||
        res.data;

      setQuotations(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchQuotations();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this quotation?")) return;

    try {
      await deleteQuotationApi(id);
      fetchQuotations();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-6">
        Quotation List
      </h1>

      <table className="w-full border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="border p-2">Client</th>
            <th className="border p-2">Project</th>
            <th className="border p-2">Total</th>
            <th className="border p-2">Additional Amount</th>
            <th className="border p-2">Status</th>
            <th className="border p-2">Actions</th>
          </tr>
        </thead>

        <tbody>
          {quotations.map((q) => (
            <tr key={q._id}>
              <td className="border p-2">
                {q.client?.name || "N/A"}
              </td>

              <td className="border p-2">
                {q.project?.name || "N/A"}
              </td>

              <td className="border p-2">
                ₹ {q.total}
              </td>

              <td className="border p-2">
                Rs. {Number(q.additionalAmount || 0).toFixed(2)}
              </td>

              <td className="border p-2">
                <span
                  className={`px-2 py-1 rounded text-white ${
                    q.status === "approved"
                      ? "bg-green-500"
                      : q.status === "sent"
                      ? "bg-yellow-500"
                      : "bg-gray-500"
                  }`}
                >
                  {q.status}
                </span>
              </td>

              <td className="border p-2">
                <button
                  onClick={() => handleDelete(q._id)}
                  className="text-red-500"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}

          {quotations.length === 0 && (
            <tr>
              <td colSpan="6" className="text-center p-4">
                No quotations found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default QuotationList;
